module.exports = __webpack_public_path__ + "static/blog-splash-4-thumbnail-da0ffd9eba8136933612b8a702f010da.jpg";